const queries = `
  mutation featured($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, featured: $state) {id, featured}}
  mutation allowincart($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, allowincart: $state) {id, allowincart}}
  mutation showincatalog($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, showincatalog: $state) {id, showincatalog}}
  mutation allowinpos($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, allowinpos: $state) {id, allowinpos}}
`

export default {
  namespaced: true,
  state: {
    wineproducts: []
  },
  mutations: {
    SET_WINE_LIST: (state, payload) => {
      state.wineproducts = payload
    }
  },
  actions: {
    updateWineList: ({ commit }, payload) => {
      commit('SET_WINE_LIST', payload)
    },
    saveOrder: ({ state, getters, rootGetters, commit, dispatch }) => {
      const newProductOrder = state.wineproducts.map(p => p.nid)
      return dispatch('blob/save', {blobID: 'wine-product-sort-order', blobData: newProductOrder}, {root: true})
        .then(_ => {
          return commit('STORE_ADHOC_STORAGE', { key: 'winecatalog', data: state.wineproducts }, { root: true })
        })
    },
    saveContentFlag: ({ rootGetters, commit, dispatch }, payload) => {
      return rootGetters['getGraphQLClient'](null, queries).mutate({
        opName: payload.type,
        variables: {
          id: payload.nid,
          state: payload.state
        }
      })
        .then(resp => {
          if (resp.errors) {
            throw new Error(resp.errors)
          }
          let winelist = rootGetters['getAdHocStorageValue']('winecatalog')
          const updateIndex = winelist.findIndex(element => element.nid === resp.data.flag.id)
          switch (payload.type) {
          case 'featured':
            winelist[updateIndex][payload.type] = resp.data.flag[payload.type]
            break
          case 'allowincart':
            winelist[updateIndex][payload.type] = resp.data.flag[payload.type]
            winelist[updateIndex].product_settings[payload.type] = resp.data.flag[payload.type]
            winelist[updateIndex].productsettings[payload.type] = resp.data.flag[payload.type]
            break
          default:
            winelist[updateIndex].product_settings[payload.type] = resp.data.flag[payload.type]
            winelist[updateIndex].productsettings[payload.type] = resp.data.flag[payload.type]
            break
          }
          commit('STORE_ADHOC_STORAGE', { key: 'winecatalog', data: winelist }, { root: true })
          return resp
        })
        .catch(err => {
          dispatch('reportError', {
            type: 'error',
            title: 'Failed Update Product',
            text: `<p>The system encountered an error attempting save product data</p>
                  <p><stong>Error: </strong>${err.message}</p>`,
            notification: true,
            showClose: true,
            timeout: 5000
          }, {root: true})
        })
    }
  },
  getters: {
    getWineProducts(state) {
      return state.wineproducts
    }
  }
}
